export const getKidsProfiles = async (omneoClient, profileIds = []) => {
  const profilePromises = profileIds.map(async (profileId) => {
    const connection = omneoClient.client.profile.Connection(profileId)
    const childProfile = await connection.get()
    const measurements = []

    // Get Child Measurements
    const { data: getChildMeasurements } = await omneoClient.profileClient.getChildMeasurements(profileId)
    if (getChildMeasurements.length) {
      for (const interaction of getChildMeasurements) {
        const interactionDate = new Date(interaction.created_at)
        measurements.push({ ...interaction?.meta?.measurement, date: interactionDate.toDateString(), rawDate: interaction.created_at })
      }
    }

    return {
      ...childProfile,
      connectionId: profileId,
      measurements
    }
  })

  return Promise.all(profilePromises)
}
